import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

import { ServiceState } from '../../../components/system/models/ServiceState';
import { billingModelFactory } from './Balance';

const billingServiceStateFactory = {
    createForProject(projectId) {
        const currentPid = BoundCurrentUserSelectors.getPid();

        if (currentPid === projectId) {
            return billingServiceStateFactory.createForOwnProject();
        }
        return _createBillingServiceState({
            getProjectId: () => projectId,
        });
    },

    // cache repository for own project as it's used in multiple places
    // TODO: consider switching to a single repository that caches specific model instances instead
    createForOwnProject() {
        if (!_ownBillingModelRepositorySingleton) {
            _ownBillingModelRepositorySingleton = _createBillingServiceState({
                getProjectId: () => BoundCurrentUserSelectors.getPid(),
            });
        }
        return _ownBillingModelRepositorySingleton;
    },
};

export { billingServiceStateFactory };

let _ownBillingModelRepositorySingleton;

// getProjectId is used to delay retrieval of a project id
// right now this is needed as a workaround as some code that uses `createForOwnProject` gets executed before `projectRepository` gets its data loaded
// to fix, we should move instantiation of any data-dependant stuff like billingService after the basic data gets loaded
function _createBillingServiceState({ getProjectId }) {
    return new ServiceState({
        createSingleModelInstance: () =>
            billingModelFactory.createModelInstanceById(getProjectId()),
        fetchSingleModelInstance: () =>
            billingModelFactory.fetchModelInstanceById(getProjectId()),
    });
}
